import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { bookTypes, bookActions } = createActionsStructure('book', [
  { name: 'ADD_BOOKING', async: true },
  { name: 'SAVE_BOOKING', async: false },
  { name: 'ADD_SAVED_BOOKING', async: true },
  { name: 'GET_DEPARTURE_TIME', async: true },
  { name: 'CLEAR_DEPARTURE_TIME', async: false },
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/BookActions.js